import apiService from './api';

export interface Colour {
  id: number;
  name: string;
  code: string | null;
  isActive: boolean;
}

// Admin-managed colour master. Yarn Inward validates its colour + code against this list.
export const getColours = async (): Promise<Colour[]> => {
  const res: any = await apiService.get('/colours');
  return (res.colours || []) as Colour[];
};

export const createColour = async (data: { name: string; code?: string }): Promise<Colour> => {
  const res: any = await apiService.post('/colours', data);
  return res.colour as Colour;
};

export const updateColour = async (id: number, data: Partial<{ name: string; code: string; isActive: boolean }>): Promise<Colour> => {
  const res: any = await apiService.put(`/colours/${id}`, data);
  return res.colour as Colour;
};

export const deleteColour = async (id: number): Promise<void> => {
  await apiService.delete(`/colours/${id}`);
};

// True when the (colour, code) pair matches an active master entry — or when the master is
// empty (not curated yet, so nothing is blocked). Mirrors the backend rule.
export const isColourAllowed = (colours: Colour[], colour: string, code: string): boolean => {
  const c = (colour || '').trim().toLowerCase();
  const cc = (code || '').trim().toLowerCase();
  if (!c && !cc) return true;                    // no colour entered
  const active = colours.filter((x) => x.isActive);
  if (active.length === 0) return true;          // master not curated yet
  return active.some((x) =>
    (!c || (x.name || '').trim().toLowerCase() === c) &&
    (!cc || (x.code || '').trim().toLowerCase() === cc)
  );
};
